<template>
  <div>
    <FilterToolbar
      :hasChanges="hasChanges"
      :appliedFilters="appliedFilters"
      @search="search"
      @update="update"
      @clear="clear">
      <DateFilter
        class="border-b"
        v-model="filters.timestamps.created_at"
        :filter="filterOptions.invoicedAt"
        @input="change"
      />
      <DateFilter
        v-model="filters.timestamps.terms_date_due"
        :filter="filterOptions.dueAt"
        @input="change"
      />
    </FilterToolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as filterOptions from './FilterOptions'
import FilterToolbar from '@/components/Filters/FilterToolbar'
import DateFilter from '@/components/Filters/DateFilter'

export default {
  components: {
    DateFilter,
    FilterToolbar
  },
  data () {
    return {
      hasChanges: false,
      filters: null,
      filterOptions: filterOptions
    }
  },
  computed: {
    ...mapGetters(['context'])
  },
  methods: {
    change () {
      this.hasChanges = true
    },
    search (searchQuery) {
      this.filters.search = {
        parameter: 'search',
        query: searchQuery
      }
      this.$emit('filter', this.filters)
    },
    update () {
      this.hasChanges = false
      this.filters.preset = 'custom'
      this.$emit('filter', this.filters)
    },
    clear () {
      this.filters = {
        preset: 'all',
        facets: {},
        search: {},
        timestamps: {}
      }
      this.$emit('filter', this.filters)
    }
  },
  mounted () {

  },
  props: {
    appliedFilters: {
      type: Object,
      required: true
    }
  },
  watch: {
    appliedFilters: {
      deep: true,
      immediate: true,
      handler (filters) {
        this.filters = filters
      }
    }
  }
}
</script>
